import { groupAndSortItemsWithHistory } from "utils/itemsWithHistory";

import type { Pin, Snooze } from "models";

export type PaginatedItems<T> = {
  items: T[] | null;
  nb_pages: number;
  nb_items: number;
};

export const groupAndSortPaginatedItems = <T extends Pin | Snooze>(paginatedItems: PaginatedItems<T>) => ({
  ...paginatedItems,
  items: groupAndSortItemsWithHistory(paginatedItems.items)
});
